import AnimeInfoPage from './AnimeInfo';

export default AnimeInfoPage;
